import { useContextWithValidation } from '@adsk/alloy-react-context';

import LocaleContext from '../context';

export default (): {
  locale: string | undefined;
  setLocale: ((locale: string) => void) | undefined;
} => {
  const contextValue = useContextWithValidation(LocaleContext, {
    hook: 'useLocale',
    provider: 'LocaleProvider',
  });

  return {
    locale: contextValue?.locale,
    setLocale: contextValue?.setLocale,
  };
};
